module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_4.1d9dd93b.jpg";